import React from 'react'
import medical from '../../assets/medical/medical.jpg'
import med1 from '../../assets/medical/med1.png'
import med2 from '../../assets/medical/ruby2.png'
import med3 from '../../assets/medical/ruby3.png'
import med4 from '../../assets/medical/ruby5.png'
import medic1 from '../../assets/medical/ruby7.jpg'
import medic2 from '../../assets/medical/ruby6.jpg'
import image5 from '../../assets/medical/ruby9.png'
import image6 from '../../assets/medical/ruby10.png'

import medic3 from '../../assets/medical/medic3.jpg'
import form from '../../assets/dental/form.png'
import { useCreateMedicalContactMutation } from '../../store/api/contact'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { FiArrowUpRight } from "react-icons/fi";
import Loader from "../../components/common/Loader";
import Dentalanimations from '../../../src/assets/animations/Doctor.json'
import "@fontsource/playfair-display/700.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
function Medical() {

    const { ref: sectionRef, inView: sectionInView } = useInView({
        triggerOnce: true, // runs only once when the section comes into view
        threshold: 0.3,    // 20% visible triggers the animation
    });
    const [selectedFiles, setSelectedFiles] = useState([])
    const [loading, setLoading] = useState(true);
    const [showSuccess, setShowSuccess] = useState(false);;
    const [formData, setFormData] = useState({
        fullName: '',
        phoneNumber: '',
        address: '',
        age: '',
        gender: '',
        quotation: '',
        condiotionsandneeds: '',
    });
    const [createMedicalContact, { isLoading, isSuccess, error }] =
        useCreateMedicalContactMutation();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };




   useEffect(() => {
    setTimeout(() => setLoading(false), 2000); // 2 seconds
}, []);


 

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles((prev) => [...prev, ...files]);
    };

    const handleRemoveFile = (index) => {
        setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("full_name", formData.fullName);
        data.append("phone_number", formData.phoneNumber);
        data.append("address", formData.address);
        data.append("age", formData.age);
        data.append("gender", formData.gender);
        data.append("quotation", formData.quotation);
        data.append("conditions_and_needs", formData.condiotionsandneeds);

        // Append multiple files
        selectedFiles.forEach((file) => {
            data.append("files", file);
        });

        try {
            const res = await createMedicalContact(data).unwrap();
            console.log("✅ Successfully submitted:", res);

            setFormData({
                fullName: '',
                phoneNumber: '',
                address: '',
                age: '',
                gender: '',
                quotation: '',
                condiotionsandneeds: '',
            });
            setSelectedFiles([]);
        } catch (err) {
            console.error("❌ Submission failed:", err);
        }
    };
    const navigate = useNavigate()
    const metrics = [
        {
            value: 30000,
            suffix: "+",
            description: "Inpatients Annually",
        },
        {
            value: 120000,
            suffix: "+",
            description: "Outpatients Treated Every Year",
        },
        {
            value: 100,
            description: "Comprehensive Multi-Speciality Treatments",
        },
    ];

    const items = [
        {
            title: "Cancer Care",
            description:
                "Comprehensive cancer treatment under one roof — Radiation, Medical & Surgical Oncology, Research, and Bone Marrow Transplant Unit.",
            imgSrc: med1,
            imgAlt: "Cancer care team in front of the specialty center",
            href: "#",
        },
        {
            title: "Cardiac Care",
            description:
                "Cardiac Center with advanced OTs and Cath Labs, supported by experienced cardiologists and surgeons for complex procedures.",
            imgSrc: med2,
            imgAlt: "Cardiac cath lab entrance decorated with flowers",
            href: "#",
        },
        {
            title: "Cardiology",
            description:
                "World-class cardiac care offering advanced diagnostics, minimally invasive procedures, and successful complex heart surgeries.",
            imgSrc: med3,
            imgAlt: "Cancer care team in front of the specialty center",
            href: "#",
        },
        {
            title: "Neurology",
            description:
                "Established in 1959 under the glorious leadership of Dr R. S. Wadia, the Neurology department of Ruby Hall Clinic was the first of its kind in Pune, and has since maintained a leading position by achieving significant milestones through the years",
            imgSrc: med4,
            imgAlt: "Cardiac cath lab entrance decorated with flowers",
            href: "#",
        },
    ]
    const cards = [
        {
            id: 1,
            title: "Advanced Technology",
            description: "Cutting-edge medical equipment for accurate diagnosis and effective treatments.",
            image: medic1,
            span: "col-span-1",
        },
        {
            id: 2,
            title: "Personalized Care",
            description: "Tailored healthcare solutions to meet individual patient needs.",
            image: medic2,
            span: "col-span-1",
        },
        {
            id: 3,
            title: "National Accreditations",
            description: "Recognized for adhering to the highest standards of healthcare quality and safety.",
            image: medic3,
            span: "col-span-1 md:col-span-2",
        },
    ]

    return (
        <>
            {loading ? (
                <Loader animation={Dentalanimations} size={400} bgColor="gray-100" />
            ) : (

                <div>


                    <section className="bg-[#F5E9D6] relative">
                        <div
                            className="flex items-center justify-center min-h-[50vh] sm:min-h-[60vh] md:min-h-[50vh] lg:min-h-[100vh] bg-cover bg-center relative "
                            style={{ backgroundImage: `url(${medical})` }}
                        >
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className='flex justify-center mt-10'>
                                <div className="flex flex-col items-center justify-center text-center relative z-10 px-4 ">
                                    <h1 className="animate-h1  font-medium md:font-bold text-xl md:text-5xl lg:text-6xl text-white mb-4 tracking-wider ">
                                        RUBY HALL CLINIC
                                    </h1>
                                    <h2 className="animate-h2 font-['Rufina'] font-light text-medium md:text-2xl text-[#F5F3F1] mb-12 max-w-3xl leading-relaxed">
                                        Over 50 Years of Excellence in Multi-Specialty Healthcare
                                    </h2>
                                    <button
                                        onClick={() => navigate('/book-appointment')}
                                        className="animate-btn flex items-center gap-2 bg-[#5B656F] hover:bg-slate-600 text-white font-['Raleway'] py-3 px-8 md:py-4 md:px-10 rounded-lg duration-300 text-medium  md:text-lg tracking-wide"
                                    >
                                        Book Your Appointment
                                        <FiArrowUpRight className="text-xl" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section
                        ref={sectionRef}
                        className="bg-gradient-to-b from-[#F5E9D6] to-[#F5F3F1]"
                    >
                        <div className="mx-auto max-w-5xl px-6 py-16 sm:px-8 lg:px-12">
                            <div className="text-center">
                                <h2 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 font-['Rufina]">
                                    Why Patients Trust <span className="text-primary">Us</span>
                                </h2>
                            </div>

                            <div className="mt-12 grid gap-6 md:grid-cols-3 py-6">
                                {metrics.map((metric) => (
                                    <article
                                        key={metric.value}
                                        className="rounded-[calc(var(--radius)*2)] bg-card px-8 py-10 md:py-6 text-center shadow-lg bg-[#FFFFFF] transition-shadow hover:shadow-xl rounded-tl-[40px]"
                                    >
                                        <h3 className="text-2xl font-[600] md:text-2xl font-[Raleway]">
                                            {sectionInView ? (
                                                <>
                                                    <CountUp
                                                        start={0}
                                                        end={metric.value}
                                                        duration={2.5}
                                                        separator=","
                                                    />
                                                    <span className="text-primary text-xl font-bold">+</span>

                                                </>

                                            ) : (
                                                <>
                                                    0<span className="text-primary">+</span>
                                                </>
                                            )}
                                        </h3>
                                        <p className="mt-3 text-sm font-medium leading-relaxed font-[Rufina]">
                                            {metric.description}
                                        </p>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="py-12 md:py-16 bg-gradient-to-b from-[#F5F3F1] to-[#F5E9D6]">
                        <div className="mx-auto max-w-6xl px-4 md:px-6">
                            <h2 className="text-center text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 font-['Rufina]">Our Specialities</h2>
                            <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
                                {items.map((item) => (
                                    <article
                                        key={item.title}
                                        className="bg-card text-card-foreground   rounded-tl-[40px] rounded-br-[40px]  border border-border shadow-sm hover:shadow-md transition-shadow overflow-hidden bg-[#FFFFFF] "
                                    >
                                        <div className="aspect-[16/9] w-full overflow-hidden p-4">
                                            <img
                                                src={item.imgSrc || "/placeholder.svg"}
                                                alt={item.imgAlt}
                                                className="h-full w-full object-cover rounded-tl-[40px] rounded-br-[40px]"
                                                loading="lazy"
                                            />
                                        </div>

                                        <div className="p-4 md:p-6">
                                            <h3 className="text-lg font-semibold ext-[#181D24] font-[Raleway] ">{item.title}</h3>
                                            <p className="mt-2 text-[#181D24] md:text-sm text-sm font-[Raleway] ">{item.description}</p>
                                            <a
                                                href={item.href}
                                                aria-label={`Learn more about ${item.title}`}
                                                className="mt-4 inline-flex text:sm md:text-sm p-2 text-white items-center rounded-md bg-[#5B656F]  font-[Raleway] "
                                            >
                                                Learn More
                                            </a>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </section>
                    <section className="w-full bg-gradient-to-b from-[#F5E9D6] to-[#F5F3F1]  py-16 px-4 md:px-8">
                        <div className="max-w-7xl mx-auto">
                            <div className="text-center mb-12">
                                <h2 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 ">Quality You Can Rely On</h2>
                                <p className="text-[#181D24] md:text-base text-sm font-[Raleway] text-center max-w-2xl mx-auto leading-relaxed">
                                    Ruby Hall Clinic is Pune's first nationally accredited multi-speciality centre with a NABH & NABL
                                    certifications and Green OT recognition, reflecting our commitment to quality, safety, and world-class
                                    healthcare.
                                </p>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {cards.map((card, index) => (
                                    <div
                                        key={card.id}
                                        className={`flex flex-col  ${card.span} bg-white rounded-tr-[40px] rounded-bl-[40px] shadow-lg overflow-hidden hover:shadow-xl  transition-shadow duration-300 ${index === 2 ? 'md:h-[500px] h-96' : ''}  // only third card`}
                                    >
                                        <div className="p-6 md:p-6 flex-1">
                                            <h3 className="text-2xl font-[500] font-[Raleway] text-[#1D221B] mb-3">{card.title}</h3>
                                            <p className="text-[#181D24] md:text-base text-sm font-[Rufina] leading-relaxed">{card.description}</p>
                                        </div>
                                        <div className="aspect-[16/9] w-full overflow-hidden p-4 mb-2 ">
                                            <img
                                                src={card.image || "/placeholder.svg"}
                                                alt={card.title}
                                                className="h-full w-full object-cover rounded-tr-[40px] rounded-bl-[40px]"
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    <section className="bg-gradient-to-b from-[#F5F3F1] to-[#F5E9D6] md:py-16 py-0 px-6">
                        <div className="max-w-5xl mx-auto text-center space-y-10">
                            <h2 className="text-2xl  md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4">
                                Your Medical Journey Made Simple
                            </h2>
                            <p className="text-[#181D24] md:text-base text-sm font-[Raleway] text-center max-w-2xl mx-auto leading-relaxed">
                                AJ Hospitality ensures a seamless experience by coordinating with Ruby Hall Clinic on behalf of guests for consultation, preparation, and stay.
                            </p>

                            {/* Image section */}
                            <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
                                <img
                                    src={image5}
                                    alt="Medical journey image 1"
                                    className="w-full md:w-1/2 h-[300px] md:h-[400px] object-cover rounded-tr-[50px] rounded-bl-[50px] shadow-lg"
                                />
                                <img
                                    src={image6}
                                    alt="Medical journey image 2"
                                    className="w-full md:w-1/2 h-[300px] md:h-[400px] object-cover rounded-tr-[50px] rounded-bl-[50px] shadow-lg"
                                />
                            </div>
                        </div>
                    </section>

                    <section>
                        <div className="min-h-screen bg-gradient-to-b from-[#F5E9D6] to-[#F5F3F1] flex items-center justify-center p-4 sm:p-6 lg:p-8">
                            <div className="bg-[#FFFBF4] rounded-tr-[40px] rounded-bl-[40px] shadow-lg max-w-6xl w-full p-8   sm:p-12">
                                <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 ">
                                    <div>
                                        <h1 className="text-3xl font-bold font-[Raleway] text-gray-900 mb-2">Medical Information Request</h1>
                                        <p className="text-gray-600 mb-8 font-[Rufina] ">
                                            Help us understand needs better.
                                        </p>
                                        <form onSubmit={handleSubmit} className="space-y-6  font-[Raleway]">
                                            <div className="grid sm:grid-cols-2 gap-4">
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        name="fullName"
                                                        value={formData.fullName}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Full Name
                                                    </label>
                                                </div>
                                                <div className="relative">
                                                    <input
                                                        type="tel"
                                                        name="phoneNumber"
                                                        value={formData.phoneNumber}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Phone Number
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='grid sm:grid-cols-2 gap-4'>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        name="address"
                                                        value={formData.address}
                                                        onChange={handleChange}
                                                        className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                        required
                                                    />
                                                    <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                        Address
                                                    </label>
                                                </div>
                                                <div className="grid sm:grid-cols-2 gap-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            name="age"
                                                            value={formData.age}
                                                            onChange={handleChange}
                                                            className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                            required
                                                        />
                                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                            Age
                                                        </label>
                                                    </div>
                                                    <div className="relative">
                                                        <select
                                                            name="gender"
                                                            value={formData.gender}
                                                            onChange={handleChange}
                                                            className="w-full border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-gray-600 px-3 py-3 text-[10px] appearance-none"
                                                            required
                                                        >
                                                            <option value="">Select Gender</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                            <option value="other">Other</option>
                                                        </select>
                                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                            Gender
                                                        </label>
                                                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <fieldset className="grid gap-2">
                                                <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">
                                                    Would you like a quotation?
                                                </legend>
                                                <div className="flex gap-3">
                                                    <button
                                                        type="button"
                                                        onClick={() => setFormData({ ...formData, quotation: 'yes' })}
                                                        className={`px-3 py-1 rounded-md text-[10px] md:text-[12px] border transition-colors duration-200 
                                                ${formData.quotation === 'yes'
                                                                ? 'bg-[#5B656F] text-white border-[#5B656F]'
                                                                : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100'}`}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => setFormData({ ...formData, quotation: 'no' })}
                                                        className={`px-3 py-1 rounded-md text-[10px] md:text-[12px] border transition-colors duration-200 
                                                ${formData.quotation === 'no'
                                                                ? 'bg-[#5B656F] text-white border-[#5B656F]'
                                                                : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-100'}`}
                                                    >
                                                        No
                                                    </button>
                                                </div>
                                            </fieldset>
                                            <div className="relative">
                                                <input
                                                    type="file"
                                                    id="fileUpload"
                                                    multiple
                                                    onChange={handleFileChange}
                                                    className="hidden"
                                                />
                                                <div
                                                    onClick={() => document.getElementById("fileUpload").click()}
                                                    className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-6 text-[10px] text-gray-500 cursor-pointer hover:bg-gray-50 transition relative"
                                                    style={{ borderWidth: "2px", borderColor: "#ccc", borderStyle: "dotted" }}
                                                >
                                                    {selectedFiles.length === 0 ? (
                                                        <p className="text-center text-gray-400 text-xs">
                                                            Click here to upload previous medical reports (if any)
                                                        </p>
                                                    ) : (
                                                        <div className="flex flex-wrap gap-3 justify-start">
                                                            {selectedFiles.map((file, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="relative border p-2 rounded-md w-20 h-20 flex items-center justify-center text-[10px] text-gray-600"
                                                                >
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleRemoveFile(index);
                                                                        }}
                                                                        className="absolute -top-2 -right-2 bg-gray-200 hover:bg-red-500 text-gray-600 hover:text-white rounded-full w-5 h-5 flex items-center justify-center text-[10px] shadow"
                                                                    >
                                                                        ✕
                                                                    </button>
                                                                    {file.type.startsWith("image/") ? (
                                                                        <img
                                                                            src={URL.createObjectURL(file)}
                                                                            alt={file.name}
                                                                            className="w-full h-full object-cover rounded-md"
                                                                        />
                                                                    ) : file.type === "application/pdf" ? (
                                                                        <div className="text-center text-[10px] flex flex-col items-center justify-center">
                                                                            <i className="fa-solid fa-file-pdf text-red-500 text-lg"></i>
                                                                            <p className="truncate w-14">{file.name}</p>
                                                                        </div>
                                                                    ) : (
                                                                        <p className="truncate">{file.name}</p>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Upload previous medical reports (if any)
                                                </label>
                                            </div>

                                            <div className="relative">
                                                <textarea
                                                    name="condiotionsandneeds"
                                                    value={formData.condiotionsandneeds}
                                                    onChange={handleChange}
                                                    placeholder='Please provide as much details as possible about your medical condition and what you are looking for.'
                                                    rows="2"
                                                    className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] resize-none"
                                                />
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Describe your condition and needs
                                                </label>
                                            </div>
                                            {showSuccess && (
                                                <div className="mb-4 p-3 bg-green-100 text-green-700 text-center rounded-lg">
                                                    Form submitted successfully!
                                                </div>
                                            )}

                                            <button
                                                type="submit"
                                                className="w-full bg-[#5B656F] hover:bg-[#3a4558] text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                            >
                                                Submit Application
                                                <FiArrowUpRight className="text-xl" />
                                            </button>
                                        </form>
                                    </div>
                                    <div className="hidden lg:flex items-center justify-center">
                                        <div className="relative w-full h-full min-h-[500px]">
                                            <img
                                                src={form}
                                                alt="Travel map with sunglasses and accessories"
                                                className="w-full h-full object-cover  rounded-tr-[40px] rounded-bl-[40px] "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )}
        </>
    )
}

export default Medical
